var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curso-main-container pb-3"},[_c('BannerInterno',{attrs:{"icono":"far fa-question-circle","titulo":"Actividad didáctica"}}),_c('div',{staticClass:"container tarjeta tarjeta--blanca p-4 p-md-5"},[_c('div',{attrs:{"id":"Actividad_Cuestionario"}}),_c('Actividad',{attrs:{"cuestionario":_vm.cuestionario}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }